import {
  IKpiData,
  IAttendanceTrendPoint,
  IStatusDistribution,
  IDepartmentRow,
} from '../hrAnalytics.types'

export const MOCK_ATTENDANCE_KPIS: IKpiData[] = [
  {
    value: '4,440',
    label: 'EXPECTED',
    sublabel: 'Employee Days',
    accentColor: '#30B6D1',
    iconKey: 'person',
  },
  {
    value: '4,063',
    label: 'PRESENT',
    sublabel: '91.5% of expected',
    accentColor: '#00B04C',
    iconKey: 'checkCircle',
  },
  {
    value: '260',
    label: 'ABSENT',
    sublabel: '5.9% of expected',
    accentColor: '#ff9900',
    iconKey: 'warning',
  },
  {
    value: '91.5%',
    label: 'ATTENDANCE RATE',
    trend: { value: '+1.2%', positive: true },
    accentColor: '#00B04C',
    iconKey: 'chart',
  },
]

export const MOCK_ATTENDANCE_TREND: IAttendanceTrendPoint[] = Array.from(
  { length: 30 },
  (_, i) => ({
    date: `Jan ${i + 1}`,
    rate: 75 + Math.random() * 20,
  })
)

export const MOCK_STATUS_DISTRIBUTION: IStatusDistribution[] = [
  { label: 'Present', percent: 74.5, color: '#00B04C' },
  { label: 'Absent', percent: 8.2, color: '#FF4F46' },
  { label: 'Leave', percent: 3.5, color: '#ff9900' },
  { label: 'Sick Leave', percent: 2.8, color: '#00BCD4' },
  { label: 'Excused', percent: 1.5, color: '#30B6D1' },
  { label: 'Off Day', percent: 2.0, color: '#BDBDBD' },
  { label: 'Holiday In', percent: 1.2, color: '#d23f70' },
  { label: 'Holiday Out', percent: 1.0, color: '#9C27B0' },
  { label: 'Training', percent: 1.8, color: '#8BC34A' },
  { label: 'Vacation', percent: 1.5, color: '#FFC107' },
  { label: 'Maternity', percent: 1.0, color: '#E91E63' },
  { label: 'Unknown', percent: 1.0, color: '#757575' },
]

export const MOCK_ATTENDANCE_BY_DEPT: IDepartmentRow[] = [
  { name: 'HSE & Safety', expected: 210, present: 198, absent: 8, rate: 94.3 },
  { name: 'Maintenance', expected: 980, present: 912, absent: 48, rate: 93.1 },
  { name: 'Mining Operations', expected: 2100, present: 1920, absent: 128, rate: 91.4 },
  { name: 'Processing Plant', expected: 650, present: 585, absent: 42, rate: 90 },
  { name: 'Administration', expected: 180, present: 162, absent: 12, rate: 90 },
  { name: 'Fleet & Transport', expected: 320, present: 286, absent: 22, rate: 89.4 },
]

export const MOCK_ATTENDANCE_BY_ROLE: IDepartmentRow[] = [
  { name: 'Operators', expected: 1200, present: 1110, absent: 60, rate: 92.5 },
  { name: 'Technicians', expected: 800, present: 740, absent: 38, rate: 92.5 },
  { name: 'Supervisors', expected: 300, present: 282, absent: 12, rate: 94.0 },
  { name: 'Engineers', expected: 200, present: 186, absent: 8, rate: 93.0 },
  { name: 'Drivers', expected: 400, present: 360, absent: 28, rate: 90.0 },
  { name: 'Admin Staff', expected: 150, present: 138, absent: 8, rate: 92.0 },
]
